import classNames from 'classnames'
import { ContainerElement } from 'types'

const variants = {
  red: {
    container: 'bg-chili-50',
    text: 'text-chili-800',
  },
  yellow: {
    container: 'bg-warning-light',
    text: 'text-warning-dark',
  },
} as const

const sizes = {
  default: 'text-xs lg:text-sm',
  small: 'text-xs',
}

type Props = {
  variant: keyof typeof variants
  size?: keyof typeof sizes
} & ContainerElement

export const PillMessage = ({
  variant,
  children,
  className,
  size = 'default',
}: Props) => {
  return (
    <div
      className={classNames(
        'w-full rounded-full px-4 py-2 lg:w-max',
        variants[variant].container,
        className
      )}
    >
      <h5
        className={classNames(
          'font-body font-medium tracking-normal',
          variants[variant].text,
          sizes[size]
        )}
      >
        {children}
      </h5>
    </div>
  )
}
